// Version letters in send order; the backend maps "a" to the campaign and later letters to its variant mailings.
export const EMAIL_AB_TEST_VARIATIONS = ['a', 'b'] as const;

export type TEmailABTestVariation = (typeof EMAIL_AB_TEST_VARIATIONS)[number];

export enum EEmailABTestWinningMetric {
  Clicks = 'clicks',
  Conversions = 'conversions',
  Opens = 'opens',
}

export interface IEmailABTestSettings {
  fallback_variation: TEmailABTestVariation;
  is_enabled: boolean;
  test_duration_hours: number;
  test_percentage: number;
  version_a_name?: string;
  winning_metric: EEmailABTestWinningMetric;
}

export enum EEmailABTestStatus {
  NotStarted = 'not_started',
  ResolvedFallback = 'resolved_fallback',
  ResolvedWinner = 'resolved_winner',
  Testing = 'testing',
}

export interface IEmailABTestState {
  readonly is_manually_ended?: boolean;
  readonly metric_values_at_resolution?: Partial<Record<TEmailABTestVariation, number>>;
  readonly resolved_at?: string;
  readonly status?: EEmailABTestStatus;
  readonly test_started_at?: string;
  readonly winner_variation?: TEmailABTestVariation;
}

export interface IEmailABTest extends IEmailABTestSettings, IEmailABTestState {}

export const EMAIL_AB_TEST_DEFAULTS: Readonly<IEmailABTestSettings> = {
  fallback_variation: 'a',
  is_enabled: false,
  test_duration_hours: 4,
  test_percentage: 30,
  winning_metric: EEmailABTestWinningMetric.Opens,
};

export const EMAIL_AB_TEST_PERCENTAGE_OPTIONS: readonly number[] = [10, 20, 30, 40, 50];

export const EMAIL_AB_TEST_DURATION_HOURS_OPTIONS: readonly number[] = [1, 4, 8, 12, 24];
